import { initQuestionCarsRotation, rotateToMouse } from "../animations/rotateCard";
import { initClickableAmountInput, updateClickableAmountInputs } from "../forms/amountInput";
import { loadNextStepModule } from "../modules/loadNextStepModule";
import { getProductImportance } from "./productConfigurator";
import { animateProgressBar } from "./progressBar";
import { fadeOutStep, highlightSelectedSelection } from "./stepAnimations";





/**
 * 
 * @param {Product365} product365 
 * @param {Product} product 
 * @param {Cart} cart 
 */
export function initFormStep(product365, product, cart) {
    initQuestionCarsRotation()


    let formSteps = document.querySelectorAll(".form-question");
    for (let formStep of formSteps) {
        let step = formStep.dataset.formstep
        let questions = formStep.querySelectorAll(".form-question-selection")

        updateClickableAmountInputs(formStep);
        if(formStep.parentNode.classList.contains('active')) {
            animateProgressBar(step)
        }

        for (let question of questions) {
            let minProduct = question.dataset.package;
            let questionAnswer = question.querySelector(".form-step-selection-question").innerText
            question.addEventListener("click", (e) => {
                e.preventDefault();

                product365.updateNameAndImportance(minProduct, getProductImportance(minProduct));

                product.addFormAnswer(questionAnswer)
                product.updateProduct(product365);


                loadNextStepModule.getNextStep(step, product365.get().name)
                highlightSelectedSelection(question)

                fadeOutStep(formStep.parentElement);

            })
        }
    }

}
